import axiosInstance from './axios';

/**
 * Vitrine sites (carlinkit, azdome, …) — dashboard management of the data each
 * standalone storefront consumes: assigned products, hero sliders, pixels,
 * domain and contact info. The storefront design/layout lives in its own repo.
 */
export const siteService = {
  getSites: async (params = {}) => {
    const response = await axiosInstance.get('/sites', { params });
    return response.data;
  },

  getSite: async (id) => {
    const response = await axiosInstance.get(`/sites/${id}`);
    return response.data;
  },

  createSite: async (data) => {
    const response = await axiosInstance.post('/sites', data);
    return response.data;
  },

  updateSite: async (id, data) => {
    const response = await axiosInstance.put(`/sites/${id}`, data);
    return response.data;
  },

  deleteSite: async (id) => {
    const response = await axiosInstance.delete(`/sites/${id}`);
    return response.data;
  },

  /**
   * Replace the site's product assignments.
   * products: [ { product_id, position, show_on_home } ]
   */
  syncProducts: async (id, products) => {
    const response = await axiosInstance.put(`/sites/${id}/products`, { products });
    return response.data;
  },
};
